(() => {
  'use strict';
  // Presentation only: the existing consent controller owns all third-party loading.
  const messages = {
    nl: ['Klantbeoordelingen op Trustpilot', 'Bekijk ervaringen met onze winkel op Trustpilot', 'Onze klantbeoordelingen', 'Lees wat klanten over onze winkel vertellen.', 'Reviews tonen', 'Sta Personalisatie toe in je cookievoorkeuren om de Trustpilot-widget te laden.', 'De cookievoorkeuren konden niet worden geopend. Probeer de knop onderaan de pagina.'],
    en: ['Customer reviews on Trustpilot', 'Read reviews of our store on Trustpilot', 'Our customer reviews', 'Read what customers say about our store.', 'Show reviews', 'Allow Personalisation in your cookie preferences to load the Trustpilot widget.', 'Cookie preferences could not be opened. Try the button at the bottom of the page.'],
    de: ['Kundenbewertungen auf Trustpilot', 'Bewertungen unseres Shops auf Trustpilot lesen', 'Unsere Kundenbewertungen', 'Lesen Sie, was Kunden über unseren Shop sagen.', 'Bewertungen anzeigen', 'Erlauben Sie Personalisierung in Ihren Cookie-Einstellungen, um das Trustpilot-Widget zu laden.', 'Die Cookie-Einstellungen konnten nicht geöffnet werden. Nutzen Sie die Schaltfläche unten auf der Seite.'],
    fr: ['Avis clients sur Trustpilot', 'Lire les avis sur notre boutique sur Trustpilot', 'Les avis de nos clients', 'Découvrez les expériences de nos clients.', 'Afficher les avis', 'Autorisez la personnalisation dans vos préférences de cookies pour afficher le widget Trustpilot.', 'Impossible d’ouvrir les préférences de cookies. Essayez le bouton en bas de page.'],
    es: ['Opiniones de clientes en Trustpilot', 'Leer opiniones sobre nuestra tienda en Trustpilot', 'Opiniones de nuestros clientes', 'Descubre las experiencias de nuestros clientes.', 'Mostrar opiniones', 'Permite la personalización en tus preferencias de cookies para cargar el widget de Trustpilot.', 'No se pudieron abrir las preferencias de cookies. Prueba el botón al final de la página.']
  };
  const lang = document.documentElement.lang.split('-')[0].toLowerCase();
  const text = messages[lang] || messages.en;
  const readyFrames = new WeakSet();
  const updates = new Map();
  window.addEventListener('message', event => {
    if (event.origin !== 'https://widget.trustpilot.com') return;
    let data;
    try { data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; } catch { return; }
    if (!['loaded', 'ping', 'impression', 'resize-height'].includes(data?.command)) return;
    for (const [widget, update] of updates) {
      const frame = Array.from(widget.querySelectorAll('iframe')).find(frame => frame.contentWindow === event.source);
      if (frame) { readyFrames.add(frame); update(); break; }
    }
  });
  function prepare(root) {
    root.querySelectorAll('.trustpilot-widget').forEach(widget => {
      if (widget.dataset.mxproFallbackReady) return;
      let original = widget.querySelector('a[href*="trustpilot.com/review/mxprostoreparts.com"]');
      const alreadyEmbedded = !original;
      if (!original) {
        if (widget.dataset.businessunitId !== '68b55cba7630f16cf2bb440d') return;
        original = document.createElement('a');
      }
      widget.dataset.mxproFallbackReady = 'true';
      const fallback = document.createElement('div');
      fallback.className = 'mxpro-review-placeholder';
      fallback.dataset.reviewLayout = parseInt(widget.dataset.styleHeight || '0', 10) > 30 ? 'card' : 'compact';
      const link = original.cloneNode(false);
      link.className = 'mxpro-review-fallback';
      link.textContent = text[widget.dataset.sku ? 1 : 0] + ' ↗';
      link.rel = 'noopener noreferrer';
      link.href = 'https://www.trustpilot.com/review/mxprostoreparts.com';
      link.target = '_blank';
      const choice = document.createElement('div');
      choice.className = 'mxpro-review-choice';
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('data-mxpro-cookie-preferences', '');
      button.textContent = text[4];
      button.title = text[5];
      const note = document.createElement('span');
      note.className = 'mxpro-review-consent-note';
      note.textContent = text[5];
      const error = document.createElement('span');
      error.setAttribute('data-mxpro-cookie-error', '');
      error.setAttribute('role', 'status');
      error.hidden = true;
      error.textContent = text[6];
      choice.append(button, note, error);
      fallback.append(link, choice);
      widget.insertAdjacentElement('afterend', fallback);
      original.classList.add('mxpro-review-original');
      const update = () => {
        const frames = Array.from(widget.querySelectorAll('iframe'));
        const loaded = frames.some(frame => readyFrames.has(frame) && frame.getBoundingClientRect().height > 8 && getComputedStyle(frame).display !== 'none');
        widget.classList.toggle('mxpro-review-loaded', loaded);
        fallback.hidden = loaded;
        const consent = window.Shopify?.customerPrivacy?.currentVisitorConsent?.();
        choice.hidden = loaded || consent?.preferences === 'yes';
        frames.forEach(frame => resize.observe(frame));
      };
      const resize = new ResizeObserver(update);
      const changes = new MutationObserver(update);
      changes.observe(widget, {childList:true, subtree:true, attributes:true, attributeFilter:['style','height']});
      updates.set(widget, update);
      document.addEventListener('visitorConsentCollected', update);
      update();
      if (alreadyEmbedded && window.Trustpilot?.loadFromElement) window.Trustpilot.loadFromElement(widget, true);
    });
    root.querySelectorAll('.c-trustpilot-reviews__title').forEach(el => { el.textContent = text[2]; });
    root.querySelectorAll('.c-trustpilot-reviews__description').forEach(el => { el.textContent = text[3]; });
  }
  prepare(document);
  document.addEventListener('shopify:section:load', event => prepare(event.target));
})();
